import { render, staticRenderFns } from "./ChangeTablePopup.vue?vue&type=template&id=633dff5b&scoped=true&"
import script from "./ChangeTablePopup.vue?vue&type=script&lang=js&"
export * from "./ChangeTablePopup.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTablePopup.vue?vue&type=style&index=0&id=633dff5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633dff5b",
  null
  
)

export default component.exports